// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-magnifier-container{position:relative;box-sizing:border-box;mix-blend-mode:darken;max-height:400px}.img-magnifier-glass{position:absolute;border:1px solid #000;cursor:none;width:60px;height:60px;background-repeat:no-repeat}.image-content{height:100%}.zoom-options{cursor:pointer;padding-left:15px;margin-top:10px;margin-bottom:10px;display:flex}.image2{width:100%;max-height:250px}", ""]);
// Exports
module.exports = exports;
